import { render, staticRenderFns } from "./QuestionCommentField.vue?vue&type=template&id=074c923d&scoped=true"
import script from "./QuestionCommentField.vue?vue&type=script&lang=js"
export * from "./QuestionCommentField.vue?vue&type=script&lang=js"
import style0 from "./QuestionCommentField.vue?vue&type=style&index=0&id=074c923d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074c923d",
  null
  
)

export default component.exports